module.exports = __webpack_public_path__ + "img/district.681adb2d.svg";